let questions = {
	forms: [
		{
			type: 'text',
			form_type: 'text',
			class: 'col-12',
			model: 'question_code',
			validation: 'required|min:3|max:300',
			label: 'Question',
			placeholder: 'Provide a question',
		},
		{
			type: 'text',
			form_type: 'text',
			class: 'col-12',
			model: 'answer',
			validation: 'required|min:3|max:100',
			label: 'Answer',
			placeholder: 'Provide the answer',
		},
	],
	table: {
		icon: 'fa fa-sitemap',
		title: 'Security Questions',
		table_fields: [
			{ name: 'Question', align: 'c' },
			{ name: 'Answer', align: 'c' },
			{ name: 'Actions', align: 'c' },
		],
		search_fields: ['question_code', 'answer'],
		row_data: [
			{ type: 'text', field: 'question_code', class: 'bold center' },
			{ type: 'text', field: 'answer', class: 'small center' },
			{
				type: 'action',
				field: 'name',
				class: 'center',
				icon: '',
				actions: [
					// {type: 'title', title: 'Actions'},
					{ type: 'menu', title: 'View', event: 'table:view' },
					{
						type: 'menu',
						title: 'Delete',
						event: 'table:delete',
						icon: 'fa-trash-alt',
					},
				],
			},
		],
	},
};

let forms = {
	update_profile: {
		icon: 'fa fa-user',
		title: 'Change Profile',
		subtitle: 'Change your profile details',
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12  col-md-6',
				model: 'first_name',
				validation: 'required|min:3|max:150',
				label: 'First Name',
			},
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12  col-md-6',
				model: 'last_name',
				validation: 'required|min:3|max:150',
				label: 'Last Name',
			},
			// {
			//    type: 'text', form_type: 'email', class: 'col-12 col-md-6', model: 'email',
			//    validation: 'required|min:3|max:150|email', label: 'Email', placeholder: 'Provide an email'
			// },
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'contact',
				validation: 'required|min:3|max:150|numeric',
				label: 'Contact',
			},
			{
				type: 'upload',
				class: 'col-12',
				model: 'profilePhoto',
				validation: 'required',
				label: 'Profile Photo',
				multiple: false,
			},
		],
	},
	send_invite: {
		icon: 'fa fa-user',
		title: 'Send Invite',
		subtitle: 'Invite your friends to Nexus',
		forms: [
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'email',
				validation: 'required|min:3|max:150|email',
				label: 'Email',
			},
			{
				type: 'textarea',
				form_type: 'text',
				class: 'col-12',
				model: 'remarks',
				validation: 'min:10|max:500',
				label: 'Remarks',
				err: '',
			},
		],
	},
	change_password: {
		icon: 'fa fa-user',
		title: 'Change Password',
		subtitle: 'Change your profile details',
		forms: [
			{
				type: 'text',
				form_type: 'password',
				class: 'custom-input col-12',
				model: 'oldPassword',
				validation: 'required|min:3|max:150',
				label: 'Old Password',
			},
			{
				type: 'text',
				form_type: 'password',
				class: 'custom-input col-12',
				model: 'password',
				validation: 'required|min:3|max:150',
				label: 'New Password',
			},
			{
				type: 'text',
				form_type: 'password',
				class: 'custom-input col-12',
				model: 'confirmPassword',
				validation: 'required|min:3|max:150',
				label: 'Confirm Password',
			},
		],
	},
	security_questions: {
		icon: 'fa fa-user',
		title: 'Change Profile',
		subtitle: 'Change your profile details',
		forms: [
			{
				type: 'form-table',
				forms: questions.forms,
				table: questions.table,
				class: 'col-12',
				label: 'Security Questions',
				model: 'questions',
			},
		],
	},
};

module.exports = {
	forms: utils.generateAllFormData(forms),
};
